import Animation from "@/Shared/Animations/Animation";
import { AnimationsInlineIconNudge } from "./CustomComponents/AnimationsInlineIconNudge";

interface YellowExclamationAnimatedIconProps {
  /** Rendered as a square of this many pixels. When omitted, the icon keeps
   *  its legacy 25px footprint with baked-in margins for inline-text layouts. */
  size?: number | undefined;
}

const YellowExclamationAnimatedIcon: React.FC<
  YellowExclamationAnimatedIconProps
> = (props) => {
  const animation = (
    <Animation
      width={props.size ?? 25}
      height={props.size ?? 25}
      lottieFilesUrl="https://edit.lottiefiles.com/?src=https%3A%2F%2Fassets4.lottiefiles.com%2Fpackages%2Flf20_HYlQBb.json"
      pathToAnimation="/animations/yellow-exclamation.json"
    />
  );
  if (props.size !== undefined) {
    return animation;
  }
  return (
    <AnimationsInlineIconNudge nudge="exclamation">
      {animation}
    </AnimationsInlineIconNudge>
  );
};
export default YellowExclamationAnimatedIcon;
